import DismissibleTag from './dismissible-tag';
import ToggleTag from './ToggleTag';

export { DismissibleTag, ToggleTag };
export type { ToggleTagProps } from './ToggleTag.props';
